define('GameDayCore/GDModel/ValueObjects/Players/PlayersFile',['require','exports','module','../ValueObjectFactory','extant/extant','./PlayerFileItem'],function(require, exports, module) {
    var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant"),
        PlayerVO = require("./PlayerFileItem");

    VO.create(PlayersFile,{
    });

    /**
     * @class PlayersFile
     * @param data {Object} json object of individual player passed down from the PlayerFile VO
     */
    function PlayersFile($data) {
        var vo = VO.ensureVO(this, PlayersFile),
            data = $data;
        vo.homePlayerIDsHash = {};
        vo.awayPlayerIDsHash = {};
        vo.playerMap = {};
        vo.playerIDsArray = [];
        vo.away = parseByTeam(data,"away");
        vo.home = parseByTeam(data,"home");
        vo.getAllPlayerIds = function () {
            return this.playerIDsArray;
        };

        vo.findPlayer = function ($playerID) {
            return this.playerMap[$playerID] || null;
        };

        vo.findPlayerParentTeamID = function ($playerID) {
            return exists(this.playerMap[$playerID]) ? this.playerMap[$playerID].parent_team_id : null;
        };

        parsePlayers(vo);
    }

     //assign the player array from each team to the appropriate var
    function parseByTeam(data,$homeAway) {
        for (var i = 0, len = data.team.length; i < len; i++) {
            if (data.team[i].type === $homeAway) {
                return [].concat(data.team[i].player);
            }
        }

        return [];
    }

    function parsePlayers(vo) {
        var allPlayersByID = { },
            playerObj,
            i, len;

        for (i = 0, len = vo.home.length; i < len; i++) {
            playerObj = new PlayerVO(vo.home[i], "home");

            allPlayersByID[playerObj.id] = playerObj;
            vo.homePlayerIDsHash[playerObj.id] = playerObj;
            vo.playerIDsArray.push(playerObj.id);
        }

        for (i = 0, len = vo.away.length; i < len; i++) {
            playerObj = new PlayerVO(vo.away[i], "away");

            allPlayersByID[playerObj.id] = playerObj;
            vo.awayPlayerIDsHash[playerObj.id] = playerObj;
            vo.playerIDsArray.push(playerObj.id);
        }

        vo.playerMap=allPlayersByID;
    }

    return PlayersFile;
});
